const processInclude = require('base/util');

const jQuery = require('jquery');

window.jQuery = jQuery;
window.$ = jQuery;

require('app_byl_core/common/polyfills');

processInclude(
  require('app_byl_core/components/countrySelectorModal/countrySelectorModal')
);
